import React, { useEffect, useState } from "react";

// ═══════════════════════════════════════════════════════════════════════
// OFERTAS DA COPA 2026 — Landing "Belleza Brasileira"
// URL: /ofertasdacopa2026
// Cada banner+link é adicionado ao array OFERTAS abaixo.
// ═══════════════════════════════════════════════════════════════════════

// Adicionar cada kit aqui conforme forem enviados:
// { id, titulo, banner (URL imagem), link (URL checkout), destaque? }
const OFERTAS = [
  {
    id: 1,
    titulo: "Iracema Vibes · Assinatura Premium",
    banner: "https://static.wixstatic.com/media/e848a2_6058888482964f01915a7f9a87617b06~mv2.jpeg",
    link: "https://www.bellanor.com.br/pagina-de-produto/bellanor-kit-turimdubai-assinatura-premium-iracema-vibes-oferta-da-copa",
  },
  {
    id: 2,
    titulo: "Combo Turim Dubai · Oferta da Copa",
    banner: "https://static.wixstatic.com/media/e848a2_04f9f45c097b4ecba658dd55da9d21f9~mv2.jpeg",
    link: "https://www.bellanor.com.br/pagina-de-produto/bellanor-combo-turimdubai-oferta-da-copa",
  },
  {
    id: 3,
    titulo: "Kit Vogue Kixiki · Alto Padrão Acessível",
    banner: "https://static.wixstatic.com/media/e848a2_9e87c496332844d280de0ba59ba8a35f~mv2.jpeg",
    link: "https://www.bellanor.com.br/pagina-de-produto/campanha-kit-dubai-oferta-da-copa-belleza-brasileira",
  },
  {
    id: 4,
    titulo: "Kit Nápoles Wood · Oferta da Copa",
    banner: "https://static.wixstatic.com/media/e848a2_2cff8b974ad441ae887d9ea19b3e54aa~mv2.jpeg",
    link: "https://www.bellanor.com.br/pagina-de-produto/bellanor-kit-napoles-wood-oferta-da-copa",
  },
  {
    id: 5,
    titulo: "Combo Jolie Dubai · Oferta da Copa",
    banner: "https://static.wixstatic.com/media/e848a2_53a687fc368048589c0126cf97cdc048~mv2.jpeg",
    link: "https://www.bellanor.com.br/pagina-de-produto/kit-dubai-oferta-da-copa-belleza-brasileira",
  },
  {
    id: 6,
    titulo: "Kit Jolie Gold · Oferta da Copa",
    banner: "https://static.wixstatic.com/media/e848a2_6f7ce21508454fc98e488957a6c63581~mv2.jpeg",
    link: "https://www.bellanor.com.br/pagina-de-produto/bellanor-kit-jolie-gold-oferta-da-copa",
  },
];

// Paleta: base Bellanor (marrom escuro + dourado) + acentos Brasil (verde/amarelo/azul bandeira)
const CORES = {
  // Brasil (acentos)
  verde: "#009c3b",
  amarelo: "#ffdf00",
  azul: "#002776",
  // Bellanor (base)
  brand: "#b4876d",
  gold: "#d7be7c",
  goldSoft: "#e8cf8e",
  fundo: "#1a140f",
  fundoAlt: "#282018",
  fundoHero: "#3a2a20",
  texto: "#fdf6d8",
  textoDim: "#c9c3a8",
};

const FAQ = [
  {
    q: "Como funciona o Pagamento Flexível?",
    a: "Ao finalizar o pedido, escolha a opção Pagamento Manual. Nossa equipe entrará em contato para personalizar a forma de pagamento de acordo com sua necessidade.",
  },
  {
    q: "Posso pagar em dois cartões?",
    a: "Sim. Nossa equipe pode organizar o pagamento em dois ou mais cartões, conforme a sua necessidade.",
  },
  {
    q: "Posso pagar parte no Pix e parte no cartão?",
    a: "Sim. Essa é uma das vantagens do Pagamento Flexível Bellanor.",
  },
  {
    q: "O frete é realmente grátis?",
    a: "Sim, com limite de 10% do valor do seu investimento. Se passar, você paga apenas uma pequena diferença simbólica. Consulte as condições da campanha vigente e as regiões atendidas.",
  },
  {
    q: "Como funciona o cupom de R$ 500?",
    a: "O cupom pode ser utilizado conforme as regras da campanha. Basta aplicar o código informado antes da finalização do investimento.",
  },
  {
    q: "Em quantas vezes posso parcelar?",
    a: "Os kits participantes podem ser parcelados em até 21 vezes no cartão, conforme disponibilidade e aprovação da operadora.",
  },
  {
    q: "Os móveis possuem garantia?",
    a: "Sim. Todos os produtos Bellanor possuem garantia conforme nossa política de garantia.",
  },
  // Sugestões extras (confiança + redução de objeção + conversão)
  {
    q: "Em quanto tempo meu pedido é entregue?",
    a: "O prazo de produção e envio varia conforme o kit e a região. Assim que o pagamento é confirmado, nossa equipe informa o prazo estimado e envia código de rastreio.",
  },
  {
    q: "E se eu não gostar do móvel quando chegar?",
    a: "Você tem o direito de arrependimento previsto em lei. Além disso, nossa equipe acompanha cada entrega e resolve qualquer situação de forma humanizada.",
  },
  {
    q: "Como é feito o atendimento durante o processo?",
    a: "Um consultor Bellanor acompanha você do pedido até a montagem, tirando dúvidas, enviando fotos do processo e garantindo tranquilidade em cada etapa.",
  },
  {
    q: "As ofertas da Copa voltam ano que vem?",
    a: "Não. Esta campanha é única enquanto a Seleção Brasileira estiver classificada na Copa 2026. Preços e brindes não se repetem — nem na próxima edição.",
  },
  {
    q: "Como recebo o avental da Copa e os brindes secretos?",
    a: "Vão junto com o pedido, sem custo extra. Os brindes secretos são surpresa e variam por kit.",
  },
  {
    q: "Vocês emitem nota fiscal?",
    a: "Sim. Todo pedido Bellanor é acompanhado de nota fiscal eletrônica.",
  },
];

const CODIGO_PROMO = "COPADOMUNDO";

// Projetos 3D — Gil sobe os arquivos em /public/projetos (projeto-1.jpg ... projeto-4.jpg)
const PROJETOS_3D = [
  { img: "/projetos/projeto-1.jpg", titulo: "Seu Salão", desc: "Linha Dubai — lavatório, poltronas de luxo e sofá em off white com detalhes dourados" },
  { img: "/projetos/projeto-2.jpg", titulo: "Studio Larissa Silva", desc: "Assinatura black & wood com espelhos LED e ripado amadeirado" },
  { img: "/projetos/projeto-3.jpg", titulo: "Salão Bege Premium", desc: "Cadeiras capitonê e espelhos oval iluminados" },
  { img: "/projetos/projeto-4.jpg", titulo: "Salão Gold", desc: "Alto padrão com acabamento dourado e couro caramelo" },
];

// Avaliações Google Meu Negócio
const GOOGLE_REVIEW_URL = "https://g.page/r/CdKxxFzy2p_eEAE/review";
const GOOGLE_NOTA = "4,9";
const GOOGLE_QTD = "142";

// Meta Pixel (Facebook) — Gil, cola seu Pixel ID aqui
const META_PIXEL_ID = "180462225065846";

// Google Tag (GA4 / Google Ads) — Bellanor C-01 · 882-514-4299
const GOOGLE_TAG_ID = "G-36YB33GXNF";
// Google Ads — conta 882-514-4299, ação "Lead WhatsApp Pós Copa 2026" (valor R$1.500 fixo no painel)
const GOOGLE_ADS_ID = "AW-675933993";
const GOOGLE_ADS_LABEL = "AW-675933993/36sFCM2L0c0cEKnep8IC";

function initGoogleTag(tagId) {
  if (!tagId || typeof window === "undefined" || window._bellanorGtagInit) return;
  window._bellanorGtagInit = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + tagId;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", tagId);
  // ativa também a tag do Google Ads na mesma conta (necessário p/ medir conversão)
  if (GOOGLE_ADS_ID) window.gtag("config", GOOGLE_ADS_ID);
}

function trackGoogle(eventName, params) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    try { window.gtag("event", eventName, params || {}); } catch (_) {}
  }
}

function initMetaPixel(pixelId) {
  if (!pixelId || typeof window === "undefined" || window._bellanorPixelInit) return;
  window._bellanorPixelInit = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

function trackPixel(event, params) {
  if (typeof window !== "undefined" && window.fbq) {
    try {
      if (event.startsWith("Custom:")) window.fbq("trackCustom", event.slice(7), params || {});
      else window.fbq("track", event, params || {});
    } catch (e) { /* silencia */ }
  }
}

export default function OfertasCopa() {
  const [faqAberta, setFaqAberta] = useState(null);
  const [copiado, setCopiado] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [leadNome, setLeadNome] = useState("");
  const [leadWa, setLeadWa] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [erroForm, setErroForm] = useState("");

  useEffect(() => {
    document.title = "Ofertas da Copa 2026 · Bellanor";
    initMetaPixel(META_PIXEL_ID);
    trackPixel("ViewContent", { content_name: "Ofertas Copa 2026", content_category: "Landing" });
    initGoogleTag(GOOGLE_TAG_ID);
    trackGoogle("view_landing_copa", { page_title: "Ofertas Copa 2026", campaign: "copa2026" });
  }, []);

  function abrirModalPlantao() {
    trackPixel("Contact", { content_name: "Corretores de Plantão · Modal Aberto", content_category: "WhatsApp" });
    trackGoogle("open_whatsapp_modal", { campaign: "copa2026" });
    setErroForm("");
    setModalOpen(true);
  }

  function fecharModal() {
    if (enviando) return;
    setModalOpen(false);
  }

  function enviarModal(e) {
    if (e) e.preventDefault();
    setErroForm("");
    const nome = (leadNome || "").trim();
    const wa = (leadWa || "").replace(/\D/g, "");
    if (nome.length < 2) { setErroForm("Digite seu nome completo."); return; }
    if (wa.length < 10 || wa.length > 13) { setErroForm("Digite um WhatsApp válido com DDD."); return; }
    setEnviando(true);
    trackPixel("Lead", { content_name: "Corretores de Plantão · Form Enviado", content_category: "WhatsApp" });
    trackGoogle("generate_lead", { campaign: "copa2026", value: 1500, currency: "BRL" });

    const params = new URLSearchParams({ ref: "copa", nome, wa });
    const destino = "/api/plantao?" + params.toString();

    // dispara a conversão do Google Ads e só redireciona DEPOIS do sinal sair
    // (senão a navegação corta o beacon e a conversão não conta). Timeout de segurança.
    let navegou = false;
    const irParaDestino = () => { if (navegou) return; navegou = true; window.location.href = destino; };
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      try {
        window.gtag("event", "conversion", {
          send_to: GOOGLE_ADS_LABEL,
          value: 1500,
          currency: "BRL",
          event_callback: irParaDestino,
        });
      } catch (_) { /* silencia */ }
    }
    setTimeout(irParaDestino, 1200);
  }

  function copiarCodigo() {
    trackPixel("Custom:CopyPromoCode", { promo_code: CODIGO_PROMO });
    trackGoogle("copy_promo_code", { promo_code: CODIGO_PROMO, campaign: "copa2026" });
    try {
      navigator.clipboard.writeText(CODIGO_PROMO);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2200);
    } catch {
      // fallback
      const el = document.createElement("textarea");
      el.value = CODIGO_PROMO;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2200);
    }
  }

  function scrollToOfertas() {
    const el = document.getElementById("ofertas");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: `
        radial-gradient(ellipse at 15% 0%, ${CORES.verde}1c 0%, transparent 50%),
        radial-gradient(ellipse at 85% 100%, ${CORES.azul}22 0%, transparent 55%),
        radial-gradient(ellipse 80% 60% at 50% 30%, #2a1f17 0%, ${CORES.fundo} 55%, #100800 100%)
      `,
      color: CORES.texto,
      fontFamily: "'Inter', -apple-system, sans-serif",
      overflow: "hidden",
    }}>
      <style>{`
        @keyframes wave {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(1deg); }
        }
        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 0 0 ${CORES.amarelo}66; }
          50% { box-shadow: 0 0 0 14px ${CORES.amarelo}00; }
        }
        @keyframes shine {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        .cta-btn {
          animation: pulse 2.4s infinite;
        }
        .cta-btn:hover {
          transform: translateY(-2px);
          filter: brightness(1.1);
        }
        .kit-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 40px ${CORES.gold}33;
        }
        .kit-card {
          transition: all 240ms ease;
        }
        .shimmer {
          background: linear-gradient(90deg, ${CORES.gold} 0%, ${CORES.goldSoft} 30%, ${CORES.amarelo} 50%, ${CORES.goldSoft} 70%, ${CORES.gold} 100%);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: shine 3s linear infinite;
        }
        .flag-bar {
          background: linear-gradient(90deg,
            ${CORES.verde} 0%, ${CORES.verde} 33%,
            ${CORES.amarelo} 33%, ${CORES.amarelo} 66%,
            ${CORES.azul} 66%, ${CORES.azul} 100%);
        }
      `}</style>

      {/* Barra bandeira topo */}
      <div className="flag-bar" style={{ height: 6, width: "100%" }} />

      {/* Header */}
      <header style={{
        maxWidth: 1100, margin: "0 auto",
        padding: "20px 24px", display: "flex",
        justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12,
      }}>
        <a href="https://bellanor.com.br" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 8,
            background: `linear-gradient(135deg, ${CORES.goldSoft} 0%, ${CORES.gold} 50%, #9a8048 100%)`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 20, fontWeight: 800, color: CORES.fundo,
            boxShadow: `0 0 20px ${CORES.gold}44`,
          }}>⚽</div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: CORES.gold, letterSpacing: 1.5, fontFamily: "'Fraunces', Georgia, serif" }}>BELLANOR</div>
            <div style={{ fontSize: 9, color: CORES.textoDim, textTransform: "uppercase", letterSpacing: 1.5 }}>Belleza Brasileira · Copa 2026</div>
          </div>
        </a>
        <button onClick={scrollToOfertas} style={{
          padding: "10px 20px", borderRadius: 100,
          background: `linear-gradient(135deg, ${CORES.goldSoft}, ${CORES.gold})`,
          color: CORES.fundo, border: "none",
          fontWeight: 700, fontSize: 12, cursor: "pointer",
          letterSpacing: 0.5, textTransform: "uppercase",
        }}>Ver Ofertas ↓</button>
      </header>

      {/* Hero */}
      <section style={{
        maxWidth: 1100, margin: "0 auto",
        padding: "40px 24px 60px",
        textAlign: "center",
      }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          padding: "8px 18px", borderRadius: 100,
          background: `${CORES.gold}15`, border: `1px solid ${CORES.gold}55`,
          fontSize: 11, fontWeight: 700, color: CORES.gold,
          letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 18,
        }}>
          🇧🇷 Campanha Bellanor · Copa 2026
        </div>

        <h1 style={{
          fontSize: "clamp(36px, 6vw, 68px)",
          fontFamily: "'Fraunces', Georgia, serif",
          fontWeight: 600, lineHeight: 1.05, margin: 0, letterSpacing: -1,
        }}>
          <span className="shimmer">Belleza Brasileira</span>
        </h1>
        <div style={{
          fontSize: "clamp(16px, 2.2vw, 22px)",
          color: CORES.textoDim, marginTop: 14, maxWidth: 720, marginLeft: "auto", marginRight: "auto",
          lineHeight: 1.5,
        }}>
          Móveis Bellanor com condições <b style={{ color: CORES.gold }}>irrepetíveis</b>
          <br/>
          enquanto a <b style={{ color: CORES.verde }}>Seleção</b> estiver <b style={{ color: CORES.amarelo }}>classificada</b>.
        </div>

        {/* Aviso urgência — prorrogação último dia */}
        <div style={{
          display: "inline-block", marginTop: 24,
          padding: "12px 22px", borderRadius: 12,
          background: `linear-gradient(135deg, ${CORES.amarelo}22, ${CORES.verde}22)`,
          border: `1px solid ${CORES.amarelo}77`,
          fontSize: "clamp(13px, 1.8vw, 16px)",
          color: CORES.texto, fontWeight: 600, letterSpacing: 0.2, maxWidth: 640,
          boxShadow: `0 0 24px ${CORES.amarelo}22`,
        }}>
          🇧🇷 <b style={{ color: CORES.amarelo }}>A Seleção perdeu</b>, mas <b style={{ color: CORES.verde }}>você ainda pode ganhar</b>.<br/>
          <span style={{ color: CORES.gold, fontWeight: 700 }}>Último dia pra aproveitar!</span>
        </div>

        {/* Título CTA WhatsApp */}
        <div style={{
          marginTop: 30, fontSize: "clamp(14px, 2vw, 17px)",
          color: CORES.textoDim, lineHeight: 1.5, maxWidth: 620, marginLeft: "auto", marginRight: "auto",
        }}>
          Fale agora mesmo com nosso time no <b style={{ color: CORES.gold }}>WhatsApp</b> clicando no botão abaixo:
        </div>

        <div style={{
          display: "flex", justifyContent: "center", gap: 12, marginTop: 16, flexWrap: "wrap",
        }}>
          <button
            type="button"
            onClick={abrirModalPlantao}
            className="cta-btn"
            style={{
              display: "inline-flex", alignItems: "center", gap: 10,
              padding: "16px 30px", borderRadius: 100,
              background: `linear-gradient(135deg, #25D366 0%, #128C7E 100%)`,
              color: "#fff", border: "none", cursor: "pointer",
              fontWeight: 800, fontSize: 15,
              letterSpacing: 0.5, textTransform: "uppercase",
              boxShadow: `0 6px 24px #25D36655`,
              fontFamily: "inherit",
            }}
          >
            <span style={{ fontSize: 20 }}>💬</span> Corretores de Plantão
          </button>
        </div>

        <div style={{ marginTop: 20, fontSize: 11, color: CORES.textoDim, letterSpacing: 1 }}>
          ⏳ PRORROGAÇÃO · ÚLTIMO DIA
        </div>
      </section>

      {/* Benefícios */}
      <section style={{
        maxWidth: 1100, margin: "0 auto",
        padding: "0 24px 60px",
      }}>
        <div style={{
          textAlign: "center", marginBottom: 32,
        }}>
          <div style={{
            fontSize: 11, color: CORES.gold, letterSpacing: 2, textTransform: "uppercase", fontWeight: 700, marginBottom: 8,
          }}>Vantagens da Campanha</div>
          <h2 style={{
            fontSize: "clamp(24px, 4vw, 36px)",
            fontFamily: "'Fraunces', Georgia, serif",
            margin: 0, color: CORES.texto,
          }}>Tudo que você ganha <span style={{ color: CORES.verde }}>de graça</span></h2>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: 14,
        }}>
          {[
            { emoji: "🚚", titulo: "Frete Grátis", desc: "Pra todo o Brasil, sem valor mínimo" },
            { emoji: "💳", titulo: "Parcelamento em até 21x", desc: "Preço de fábrica parcelado" },
            { emoji: "👕", titulo: "Avental da Copa", desc: "Presente exclusivo da campanha" },
            { emoji: "🎁", titulo: "Brindes Secretos", desc: "Surpresas em cada pedido" },
            { emoji: "🎟️", titulo: "Sorteios", desc: "Concorra a prêmios especiais" },
            { emoji: "🏭", titulo: "Preço de Fábrica", desc: "Direto do produtor, sem atravessador" },
          ].map((b, i) => (
            <div key={i} style={{
              background: `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 40%, ${CORES.fundo} 100%)`,
              border: `1px solid ${CORES.gold}33`,
              borderRadius: 14, padding: 22,
              textAlign: "center",
              boxShadow: `0 4px 20px rgba(0,0,0,0.4), inset 0 1px 0 ${CORES.gold}22`,
            }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>{b.emoji}</div>
              <div style={{ fontSize: 15, fontWeight: 700, color: CORES.gold, marginBottom: 4, fontFamily: "'Fraunces', Georgia, serif" }}>{b.titulo}</div>
              <div style={{ fontSize: 12, color: CORES.textoDim, lineHeight: 1.4 }}>{b.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Pagamento Flex Bellanor */}
      <section style={{
        maxWidth: 900, margin: "0 auto",
        padding: "0 24px 40px",
      }}>
        <div style={{
          background: `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 100%)`,
          border: `1px solid ${CORES.gold}44`,
          borderRadius: 14, padding: "24px 26px",
          boxShadow: `0 4px 24px rgba(0,0,0,0.35), inset 0 1px 0 ${CORES.gold}22`,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12, flexWrap: "wrap" }}>
            <div style={{ fontSize: 30 }}>💳</div>
            <div className="serif" style={{
              fontSize: 22, fontWeight: 600, color: CORES.gold,
              fontFamily: "'Fraunces', Georgia, serif", letterSpacing: -0.2,
            }}>
              Pagamento Flex Bellanor
            </div>
          </div>
          <div style={{ fontSize: 13, color: CORES.textoDim, lineHeight: 1.65 }}>
            Na Bellanor, você não personaliza apenas seus móveis — você também personaliza a forma de pagamento.
          </div>
          <div style={{ fontSize: 13, color: CORES.textoDim, lineHeight: 1.65, marginTop: 10 }}>
            Ao finalizar seu pedido, basta selecionar a opção <b style={{ color: CORES.gold }}>Pagamento Manual</b>. Nossa equipe entrará em contato para montar a melhor forma de pagamento pra você.
          </div>
          <div style={{ fontSize: 13, color: CORES.textoDim, marginTop: 12 }}>Você poderá pagar, por exemplo:</div>
          <ul style={{ margin: "8px 0 0 0", padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 6 }}>
            {[
              "Parte no Pix e parte no cartão;",
              "Em dois ou mais cartões;",
              "Ou da forma que for mais conveniente.",
            ].map((li, i) => (
              <li key={i} style={{ fontSize: 13, color: CORES.textoDim, lineHeight: 1.5, display: "flex", gap: 10 }}>
                <span style={{ color: CORES.gold, fontWeight: 700 }}>•</span>
                <span>{li}</span>
              </li>
            ))}
          </ul>
          <div style={{ marginTop: 14, fontSize: 12.5, color: CORES.gold, fontStyle: "italic" }}>
            Mais liberdade, mais flexibilidade e uma experiência exclusiva pra você.
          </div>
        </div>
      </section>

      {/* Aviso escassez */}
      <section style={{
        maxWidth: 900, margin: "0 auto",
        padding: "0 24px 40px",
      }}>
        <div style={{
          background: `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 100%)`,
          border: `1px solid ${CORES.gold}55`,
          borderRadius: 14, padding: "20px 24px",
          display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap",
          boxShadow: `0 0 30px ${CORES.gold}11`,
        }}>
          <div style={{ fontSize: 34 }}>⏳</div>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: CORES.gold, marginBottom: 4, fontFamily: "'Fraunces', Georgia, serif" }}>
              Essa Copa não volta.
            </div>
            <div style={{ fontSize: 12.5, color: CORES.textoDim, lineHeight: 1.5 }}>
              Daqui 4 anos a inflação sobe e esses preços não existem mais. Aproveita agora enquanto a Seleção joga.
            </div>
          </div>
        </div>
      </section>

      {/* Código Promocional */}
      <section style={{
        maxWidth: 900, margin: "0 auto",
        padding: "0 24px 40px",
      }}>
        <div style={{
          background: `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 100%)`,
          border: `1px solid ${CORES.gold}66`,
          borderRadius: 14, padding: "22px 24px",
          textAlign: "center",
          boxShadow: `0 0 40px ${CORES.gold}22`,
          position: "relative", overflow: "hidden",
        }}>
          <div className="flag-bar" style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3 }} />
          <div style={{ fontSize: 10, color: CORES.gold, letterSpacing: 2, textTransform: "uppercase", fontWeight: 700, marginBottom: 8 }}>
            🎟️ Código Promocional
          </div>
          <div style={{ fontSize: 12.5, color: CORES.textoDim, marginBottom: 14, lineHeight: 1.5 }}>
            Copia o código abaixo e cola no checkout antes de finalizar seu investimento:
          </div>
          <button
            onClick={copiarCodigo}
            aria-label="Copiar código promocional"
            style={{
              display: "inline-flex", alignItems: "center", gap: 12,
              padding: "14px 22px", borderRadius: 100,
              background: `linear-gradient(135deg, ${CORES.goldSoft} 0%, ${CORES.gold} 50%, #9a8048 100%)`,
              color: CORES.fundo, border: "none", cursor: "pointer",
              fontFamily: "'Fraunces', Georgia, serif",
              fontWeight: 700, fontSize: 22, letterSpacing: 2,
              boxShadow: `0 6px 20px ${CORES.gold}55`,
            }}
          >
            <span>{CODIGO_PROMO}</span>
            <span style={{
              fontSize: 12, background: CORES.fundo + "22", padding: "4px 10px", borderRadius: 100,
              letterSpacing: 0.5, fontWeight: 700, textTransform: "uppercase",
              fontFamily: "'Inter', -apple-system, sans-serif",
            }}>
              {copiado ? "✓ Copiado!" : "📋 Copiar"}
            </span>
          </button>
          <div style={{ marginTop: 10, fontSize: 10.5, color: CORES.textoDim, opacity: 0.85 }}>
            Válido durante a campanha da Copa 2026.
          </div>
        </div>
      </section>

      {/* Ofertas / Kits */}
      <section id="ofertas" style={{
        maxWidth: 1100, margin: "0 auto",
        padding: "20px 24px 60px",
      }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            fontSize: 11, color: CORES.gold, letterSpacing: 2, textTransform: "uppercase", fontWeight: 700, marginBottom: 8,
          }}>⚽ Ofertas Ativas</div>
          <h2 style={{
            fontSize: "clamp(24px, 4vw, 36px)",
            fontFamily: "'Fraunces', Georgia, serif",
            margin: 0, color: CORES.texto,
          }}>Kits da Campanha</h2>
        </div>

        {OFERTAS.length === 0 ? (
          <div style={{
            background: `linear-gradient(135deg, ${CORES.fundoHero}, ${CORES.fundoAlt})`,
            border: `1px dashed ${CORES.gold}55`,
            borderRadius: 14, padding: 44, textAlign: "center",
            color: CORES.textoDim, fontSize: 14,
          }}>
            🔧 Ofertas sendo carregadas em breve. Volte já!
          </div>
        ) : (
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: 20,
          }}>
            {OFERTAS.map(oferta => (
              <div key={oferta.id} className="kit-card" style={{
                background: `linear-gradient(180deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 100%)`,
                border: `1px solid ${oferta.destaque ? CORES.gold : CORES.gold + "44"}`,
                borderRadius: 16, overflow: "hidden",
                display: "flex", flexDirection: "column",
                boxShadow: `0 8px 30px rgba(0,0,0,0.5)`,
              }}>
                <div style={{ position: "relative" }}>
                  <img src={oferta.banner} alt={oferta.titulo} style={{
                    width: "100%", height: "auto", display: "block",
                  }} />
                  {/* faixa bandeira no topo do banner */}
                  <div className="flag-bar" style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4 }} />
                </div>
                <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 14 }}>
                  {oferta.titulo && (
                    <div style={{
                      fontSize: 17, fontWeight: 600, color: CORES.gold,
                      fontFamily: "'Fraunces', Georgia, serif", letterSpacing: -0.2,
                    }}>{oferta.titulo}</div>
                  )}
                  <a
                    href={oferta.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      trackPixel("Lead", { content_name: oferta.titulo || `Kit ${oferta.id}`, content_ids: [String(oferta.id)], content_category: "Kit Copa 2026" });
                      trackGoogle("click_kit_offer", { kit_id: oferta.id, kit_name: oferta.titulo, campaign: "copa2026" });
                    }}
                    style={{
                      display: "block", textAlign: "center",
                      padding: "15px 20px", borderRadius: 100,
                      background: `linear-gradient(135deg, ${CORES.verde} 0%, #00b344 100%)`,
                      color: "#fff", textDecoration: "none",
                      fontWeight: 800, fontSize: 14,
                      letterSpacing: 0.8, textTransform: "uppercase",
                      boxShadow: `0 6px 20px ${CORES.verde}44, inset 0 1px 0 ${CORES.amarelo}44`,
                    }}
                  >
                    Aproveitar Oferta ⚽
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Projetos 3D */}
      <section style={{
        maxWidth: 1100, margin: "0 auto",
        padding: "20px 24px 60px",
      }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            fontSize: 11, color: CORES.gold, letterSpacing: 2, textTransform: "uppercase", fontWeight: 700, marginBottom: 8,
          }}>✏️ Projeto 3D Grátis</div>
          <h2 style={{
            fontSize: "clamp(24px, 4vw, 36px)",
            fontFamily: "'Fraunces', Georgia, serif",
            margin: 0, color: CORES.texto,
          }}>Veja seu salão <span style={{ color: CORES.gold }}>antes de montar</span></h2>
          <div style={{
            fontSize: "clamp(13px, 1.8vw, 16px)", color: CORES.textoDim,
            marginTop: 12, maxWidth: 640, marginLeft: "auto", marginRight: "auto", lineHeight: 1.5,
          }}>
            Criamos o projeto 3D do seu espaço <b style={{ color: CORES.verde }}>sem custo</b>. Escolha os móveis e visualize o resultado real antes de fechar.
          </div>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: 16,
        }}>
          {PROJETOS_3D.map((p, i) => (
            <div key={i} className="kit-card" style={{
              background: `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 40%, ${CORES.fundo} 100%)`,
              border: `1px solid ${CORES.gold}33`,
              borderRadius: 16, overflow: "hidden",
              boxShadow: `0 4px 20px rgba(0,0,0,0.4), inset 0 1px 0 ${CORES.gold}22`,
            }}>
              <div style={{ width: "100%", aspectRatio: "4 / 3", overflow: "hidden", background: CORES.fundoAlt }}>
                <img src={p.img} alt={p.titulo} loading="lazy" style={{
                  width: "100%", height: "100%", objectFit: "cover", display: "block",
                }} />
              </div>
              <div style={{ padding: 18 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: CORES.gold, marginBottom: 4, fontFamily: "'Fraunces', Georgia, serif" }}>{p.titulo}</div>
                <div style={{ fontSize: 12.5, color: CORES.textoDim, lineHeight: 1.4 }}>{p.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: 28 }}>
          <button onClick={abrirModalPlantao} className="cta-btn" style={{
            padding: "14px 30px", borderRadius: 100,
            background: `linear-gradient(135deg, ${CORES.verde}, #007a2e)`,
            color: "#fff", border: "none", fontWeight: 700, fontSize: 15,
            cursor: "pointer", letterSpacing: 0.3,
          }}>Quero meu Projeto 3D Grátis</button>
        </div>
      </section>

      {/* Avaliações Google */}
      <section style={{
        maxWidth: 900, margin: "0 auto",
        padding: "0 24px 60px",
      }}>
        <div style={{
          background: `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 100%)`,
          border: `1px solid ${CORES.gold}55`,
          borderRadius: 18, padding: "32px 24px", textAlign: "center",
          boxShadow: `0 0 30px ${CORES.gold}11`,
        }}>
          <div style={{
            fontSize: 11, color: CORES.gold, letterSpacing: 2, textTransform: "uppercase", fontWeight: 700, marginBottom: 12,
          }}>Avaliações no Google</div>
          <div style={{
            fontSize: "clamp(40px, 7vw, 60px)", fontWeight: 800, color: CORES.texto,
            fontFamily: "'Fraunces', Georgia, serif", lineHeight: 1,
          }}>{GOOGLE_NOTA}</div>
          <div style={{ fontSize: 26, letterSpacing: 3, marginTop: 8 }}>⭐⭐⭐⭐⭐</div>
          <div style={{ fontSize: 14, color: CORES.textoDim, marginTop: 12 }}>
            Nota <b style={{ color: CORES.gold }}>{GOOGLE_NOTA}</b> em <b style={{ color: CORES.gold }}>{GOOGLE_QTD}</b> avaliações reais de clientes
          </div>
          <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer"
            onClick={() => trackGoogle("click_google_reviews", { campaign: "copa2026" })}
            style={{
              display: "inline-block", marginTop: 22,
              padding: "12px 26px", borderRadius: 100,
              background: `linear-gradient(135deg, ${CORES.goldSoft}, ${CORES.gold})`,
              color: CORES.fundo, textDecoration: "none", fontWeight: 700, fontSize: 14, letterSpacing: 0.3,
            }}>Ver avaliações no Google →</a>
        </div>
      </section>

      {/* FAQ */}
      <section style={{
        maxWidth: 900, margin: "0 auto",
        padding: "20px 24px 60px",
      }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{
            fontSize: 11, color: CORES.gold, letterSpacing: 2, textTransform: "uppercase", fontWeight: 700, marginBottom: 8,
          }}>❓ Perguntas Frequentes</div>
          <h2 style={{
            fontSize: "clamp(22px, 3.6vw, 32px)",
            fontFamily: "'Fraunces', Georgia, serif",
            margin: 0, color: CORES.texto,
          }}>Tire suas dúvidas antes de investir</h2>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {FAQ.map((item, i) => {
            const aberta = faqAberta === i;
            return (
              <div key={i} style={{
                background: aberta ? `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 100%)` : CORES.fundoAlt,
                border: `1px solid ${aberta ? CORES.gold + "66" : CORES.gold + "22"}`,
                borderRadius: 12, overflow: "hidden",
                transition: "all 200ms ease",
              }}>
                <button
                  onClick={() => setFaqAberta(aberta ? null : i)}
                  aria-expanded={aberta}
                  style={{
                    width: "100%", background: "none", border: "none",
                    padding: "16px 18px",
                    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12,
                    cursor: "pointer", textAlign: "left",
                    fontFamily: "inherit", color: CORES.texto,
                  }}
                >
                  <span style={{
                    fontSize: 14, fontWeight: 600,
                    fontFamily: "'Fraunces', Georgia, serif",
                    color: aberta ? CORES.gold : CORES.texto,
                    letterSpacing: -0.1,
                  }}>{item.q}</span>
                  <span style={{
                    fontSize: 18, color: CORES.gold,
                    transform: aberta ? "rotate(45deg)" : "rotate(0deg)",
                    transition: "transform 200ms ease", flexShrink: 0,
                  }}>+</span>
                </button>
                {aberta && (
                  <div style={{
                    padding: "0 18px 18px 18px",
                    fontSize: 13, color: CORES.textoDim, lineHeight: 1.65,
                    borderTop: `1px dashed ${CORES.gold}22`,
                    marginTop: -4, paddingTop: 14,
                  }}>
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* Modal Captura Lead */}
      {modalOpen && (
        <div
          onClick={fecharModal}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: 20, zIndex: 9999, backdropFilter: "blur(4px)",
          }}
        >
          <form
            onClick={e => e.stopPropagation()}
            onSubmit={enviarModal}
            style={{
              background: `linear-gradient(135deg, ${CORES.fundoHero} 0%, ${CORES.fundoAlt} 100%)`,
              border: `1px solid ${CORES.gold}66`,
              borderRadius: 16, padding: 26,
              maxWidth: 460, width: "100%",
              boxShadow: `0 20px 60px rgba(0,0,0,0.6), 0 0 40px ${CORES.gold}22`,
              position: "relative", overflow: "hidden",
            }}
          >
            <div className="flag-bar" style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4 }} />
            <button
              type="button"
              onClick={fecharModal}
              aria-label="Fechar"
              style={{
                position: "absolute", top: 12, right: 12,
                background: "none", border: "none", cursor: "pointer",
                color: CORES.textoDim, fontSize: 22, lineHeight: 1,
              }}
            >×</button>

            <div style={{ textAlign: "center", marginBottom: 18 }}>
              <div style={{ fontSize: 34, marginBottom: 6 }}>💬</div>
              <div style={{
                fontFamily: "'Fraunces', Georgia, serif",
                fontSize: 22, fontWeight: 600, color: CORES.gold,
                lineHeight: 1.2, marginBottom: 6,
              }}>
                Falta pouco pra falar com nosso time
              </div>
              <div style={{ fontSize: 12.5, color: CORES.textoDim, lineHeight: 1.5 }}>
                Deixa seu nome e WhatsApp que já te encaminhamos pro corretor de plantão certo.
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div>
                <label style={{ fontSize: 10, color: CORES.gold, letterSpacing: 1, textTransform: "uppercase", fontWeight: 700 }}>Como gosta de ser chamada(o)?</label>
                <input
                  type="text"
                  value={leadNome}
                  onChange={e => setLeadNome(e.target.value)}
                  placeholder="Seu primeiro nome"
                  autoFocus
                  style={{
                    width: "100%", boxSizing: "border-box",
                    background: CORES.fundo, border: `1px solid ${CORES.gold}44`,
                    borderRadius: 10, padding: "12px 14px",
                    color: CORES.texto, fontFamily: "inherit", fontSize: 14,
                    marginTop: 4, outline: "none",
                  }}
                />
              </div>
              <div>
                <label style={{ fontSize: 10, color: CORES.gold, letterSpacing: 1, textTransform: "uppercase", fontWeight: 700 }}>WhatsApp (com DDD)</label>
                <input
                  type="tel"
                  value={leadWa}
                  onChange={e => setLeadWa(e.target.value)}
                  placeholder="(85) 99999-9999"
                  style={{
                    width: "100%", boxSizing: "border-box",
                    background: CORES.fundo, border: `1px solid ${CORES.gold}44`,
                    borderRadius: 10, padding: "12px 14px",
                    color: CORES.texto, fontFamily: "inherit", fontSize: 14,
                    marginTop: 4, outline: "none",
                  }}
                />
              </div>
            </div>

            {erroForm && (
              <div style={{
                marginTop: 12, padding: "8px 12px", borderRadius: 8,
                background: "#e5484d22", border: "1px solid #e5484d66",
                color: "#f88", fontSize: 12,
              }}>{erroForm}</div>
            )}

            <button
              type="submit"
              disabled={enviando}
              style={{
                marginTop: 18, width: "100%",
                padding: "15px 20px", borderRadius: 100,
                background: enviando
                  ? `linear-gradient(135deg, #666 0%, #444 100%)`
                  : `linear-gradient(135deg, #25D366 0%, #128C7E 100%)`,
                color: "#fff", border: "none",
                cursor: enviando ? "wait" : "pointer",
                fontWeight: 800, fontSize: 14,
                letterSpacing: 0.8, textTransform: "uppercase",
                boxShadow: `0 6px 20px #25D36644`,
                fontFamily: "inherit",
              }}
            >
              {enviando ? "Conectando…" : "💬 Falar com Corretor Agora"}
            </button>

            <div style={{ marginTop: 10, fontSize: 10, color: CORES.textoDim, textAlign: "center", opacity: 0.75 }}>
              Seus dados são usados apenas pra encaminhar seu atendimento.
            </div>
          </form>
        </div>
      )}

      {/* Rodapé */}
      <footer style={{
        borderTop: `1px solid ${CORES.gold}22`,
        padding: "28px 24px 44px",
        textAlign: "center",
        color: CORES.textoDim, fontSize: 11,
      }}>
        <div className="flag-bar" style={{ height: 3, maxWidth: 200, margin: "0 auto 18px", borderRadius: 3 }} />
        <div style={{ color: CORES.gold, fontFamily: "'Fraunces', Georgia, serif", fontSize: 13, letterSpacing: 0.5 }}>
          BELLANOR MÓVEIS
        </div>
        <div style={{ marginTop: 4 }}>Campanha Copa 2026 · Belleza Brasileira</div>
        <div style={{ marginTop: 8 }}>
          <a href="https://bellanor.com.br" style={{ color: CORES.gold, textDecoration: "none" }}>bellanor.com.br</a>
        </div>
        <div style={{ marginTop: 14, fontSize: 10, color: CORES.textoDim, fontStyle: "italic", opacity: 0.75 }}>
          *Imagens meramente ilustrativas.
        </div>
      </footer>
    </div>
  );
}
